import { render, staticRenderFns } from "./site-sidebar.vue?vue&type=template&id=650311eb&scoped=true"
import script from "./site-sidebar.vue?vue&type=script&lang=js"
export * from "./site-sidebar.vue?vue&type=script&lang=js"
import style0 from "./site-sidebar.vue?vue&type=style&index=0&id=650311eb&prod&scoped=true&lang=css"
import style1 from "./site-sidebar.vue?vue&type=style&index=1&id=650311eb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650311eb",
  null
  
)

export default component.exports